
























import { getContentArea } from '@/contentful';
import store from '@/store';
import {
  LoadingService,
  ExtendMixins,
} from '@/services';
import { EventBus } from '@/event-bus';
import { PageIntro, PageSidebar } from '@/components/page-components';
import { BeneficiariesReview } from '@/components/account-components';
import { OpenUpdateBeneficiariesScreen } from '@/mixins/get-content-mixins';
import { PRIMARY_BENEFICIARY, CONTINGENT_BENEFICIARY } from '@/constants';
import { AccountBeneficiaryResponseModel, CTA } from '@/@types/member';

export interface Data {
  accountId: string;
  sidebarHeading: string;
  sidebarContent: string;
  ctaConfig: CTA;
}

export default ExtendMixins(
  OpenUpdateBeneficiariesScreen,
).extend({
  name: 'Beneficiaries',
  beforeRouteEnter(to, from, next) {
    const requests = [
      store.dispatch('getBeneficiaryInformation', to.params.id),
      getContentArea('beneficiaries-sidebar-content'),
    ];
    LoadingService.watchPromises(requests)
      .then((data) => {
        const sidebar = data[1];
        if (sidebar && sidebar.fields) {
          to.meta.sidebarHeading = sidebar.fields.headline;
          to.meta.sidebarContent = sidebar.fields.content;
        }
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  data(): Data {
    return {
      accountId: this.$route.params.id,
      sidebarHeading: this.$route.meta.sidebarHeading,
      sidebarContent: this.$route.meta.sidebarContent,
      ctaConfig: {
        text: '',
        action: () => {},
      },
    };
  },
  beforeMount() {
    this.ctaConfig = {
      text: this.$options.filters.t([
        'beneficiaries_action_add-beneficiary',
        'global_add-beneficiary',
      ]),
        action: this.addBeneficiary,
    };
  },
  computed: {
    beneficiaries(): AccountBeneficiaryResponseModel[] {
      return this.$store.getters.currentBeneficiaries;
    },
  },
  methods: {
    addBeneficiary(): void {
      this.openUpdateBeneficiariesScreen({
        action: 'add',
        previousScreen: 'view',
      });
    },
    updateBeneficiaries(): void {
      this.openUpdateBeneficiariesScreen({
        showReview: true,
        previousScreen: 'view',
      });
    },
  },
  components: {
    PageIntro,
    PageSidebar,
    BeneficiariesReview,
  },
});
